import * as React from 'react';

import type {Assignable} from 'nutshell-core/types';

import {Popover} from '../../popover/popover';
import {SelectableListSingle} from '../../selectable-list/selectable-list';

import styles from './task-row.module.css';

type Props = {
    anchor: HTMLElement | null | undefined;
    assignables: Assignable[];
    assigneeId: string | null | undefined;
    setIsAssigneePopoverOpen: (isAssigneePopoverOpen: boolean) => void;
    onSelect: (assigneeId?: string | null | undefined) => void;
};

export function TaskAssigneePopover(props: Props) {
    return (
        <Popover
            anchor={props.anchor}
            location='bottom'
            onBlur={() => props.setIsAssigneePopoverOpen(false)}
        >
            <div className={styles['assignee-popover']}>
                {/* @ts-expect-error */}
                <SelectableListSingle
                    collection={props.assignables}
                    value={props.assigneeId}
                    hasSearch={true}
                    autoFocusSearch={true}
                    isNewStyle={true}
                    alwaysHasValue={true}
                    onSelect={(userId?: string | null) => {
                        props.onSelect(userId);
                    }}
                    // @ts-expect-error
                    placeholder='Assign this task...'
                />
            </div>
        </Popover>
    );
}
